export default __webpack_public_path__ + "static/media/Stage1.c3e60b20.jpg";